const get = geojson => {
    if (geojson.type === 'Point') {
        return geojson;
    }

    if (geojson.type === 'Polygon') {
        const [primeiroAnel] = geojson.coordinates;
        let x = 0;
        let y = 0;
        let count = 0;

        primeiroAnel.forEach(ponto => {
            x += ponto[0];
            y += ponto[1];
            count++;
        });

        const centroideX = x / count;
        const centroideY = y / count;

        return {
            type: 'Point',
            coordinates: [centroideX, centroideY]
        };
    }

    if (geojson.type === 'MultiPoint') {
        const [primeiroPonto] = geojson.coordinates;
        return {
            type: 'Point',
            coordinates: primeiroPonto
        };
    }

    if (geojson.type === 'MultiPolygon') {
        const [primeiroPoligono] = geojson.coordinates;
        const [primeiroAnel] = primeiroPoligono;
        let x = 0;
        let y = 0;
        let count = 0;

        primeiroAnel.forEach(ponto => {
            x += ponto[0];
            y += ponto[1];
            count++;
        });

        const centroideX = x / count;
        const centroideY = y / count;

        return {
            type: 'Point',
            coordinates: [centroideX, centroideY]
        };
    }

    return null;
};

export default {
    get
};
